<template>
  <vs-row>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-select :color="colorx" label="Choose Filter" v-model="filter">
        <vs-select-item value text="Select Filter" disabled />
        <vs-select-item value="MENU" text="Menu" />
        <vs-select-item value="EXIT" text="Exit" />
        <vs-select-item value="POPUP" text="Popup" />
        <vs-select-item value="GAMES" text="More Games" />
      </vs-select>
    </vs-col>
    <vs-col vs-lg="12" vs-xs="12" class="mt-4">
      <h6 v-if="!apps.length" class="mt-3" style="color:red;text-align:center">No Promoted Apps Found for {{ app.title }}
        !!</h6>
      <table v-if="apps.length" class="table">
        <tr>
          <th>#</th>
          <th>App Promoted</th>
          <!-- <th>Description</th> -->
          <th>Menu</th>
          <th>Exit</th>
          <th>Popup</th>
          <th>MoreGames</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in apps" :key="index">
          <td class="td">
            <h6>{{ index + 1 }}</h6>
          </td>
          <td class="td">
            <h6>{{ item.appToPromoteObject.title }}</h6>
            <small>Menu - {{ item.menuPos }}</small><br>
            <small>Exit - {{ item.exitPos }}</small><br>
            <small>Popup - {{ item.popupPos }}</small><br>
            <small>Games - {{ item.moreGamesPos }}</small><br>
          </td>
          <!-- <td class="td"><small>{{item.appToPromoteObject.description}}</small></td> -->
          <td class="td">
            <vs-chip v-if="item.isMenu" color="success">Yes</vs-chip>
            <vs-chip v-else color="danger">No</vs-chip>
          </td>
          <td class="td">
            <vs-chip v-if="item.isExit" color="success">Yes</vs-chip>
            <vs-chip v-else color="danger">No</vs-chip>
          </td>
          <td class="td">
            <vs-chip v-if="item.isPopup" color="success">Yes</vs-chip>
            <vs-chip v-else color="danger">No</vs-chip>
          </td>
          <td class="td">
            <vs-chip v-if="item.isMoreGames" color="success">Yes</vs-chip>
            <vs-chip v-else color="danger">No</vs-chip>
          </td>
          <td class="td">
            <vs-dropdown>
              <vs-icon class icon="more_vert"></vs-icon>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="editPromotedApp(item)">
                  <vs-icon class="align-right" icon="create"></vs-icon>Edit
                </vs-dropdown-item>
                <vs-dropdown-item @click="deletePromotedApp(item)">
                  <vs-icon class icon="delete_sweep"></vs-icon>Delete
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </td>
          <!-- <td class="td">
            <vs-button size="small" class="mr-2" type="filled" color="primary" @click="editPromotedApp(item)">Edit</vs-button>
            <vs-button size="small" type="filled" color="danger" @click="deletePromotedApp(item)">Delete</vs-button>
          </td> -->
        </tr>
      </table>
    </vs-col>
  </vs-row>
</template>
<script>
import api from "@/rest.js";
import { API } from "@/common/constants";

export default {
  name: "ViewPromote",
  props: {
    itemToPromote: {
      type: Object
    }
  },
  data() {
    return {
      colorx: "#0D2144",
      filter: "EXIT",
      app: this.itemToPromote,
      apps: [],
      viewDetailsPopup: false
    };
  },
  methods: {
    fetchAllPromotedApps(appKey, filter) {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .get(`${API.GET_PROMOTE_APP}?appKey=${appKey}&filter=${filter}`, {}, { headers })
        .then(r => {
          this.$vs.loading.close();
          this.$data.apps = r.data;
          if (!r.status == 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right"
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Something went wrong",
            color: "danger",
            position: "top-right"
          });
        });
    },
    editPromotedApp(i) {
      this.$emit("promoted-object", i);
    },
    deletePromotedApp(i) {
      this.$emit("delete-promoted-item", i);
    }
  },
  watch: {
    filter(newVal) {
      this.fetchAllPromotedApps(this.app.guid, newVal);
    }
  },
  created() {
    this.fetchAllPromotedApps(this.app.guid, this.filter);
  }
};
</script>
<style scoped>
.td {
  vertical-align: middle;
}
</style>